function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        // pagination_click_fun(); // reinit click event
      }
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}



document.addEventListener('click', function (event) {
  const faq = event.target.closest('.faq_Click');
  if (!faq) return;
  event.preventDefault();
  const content = document.querySelector(faq.getAttribute('data-faq_content'));
  if (faq.classList.contains('is_open')) {
    faq.classList.remove('is_open');
    if (content) {
      content.style.display = 'none';
    }
  } else {
    document.querySelectorAll('.faq_Click').forEach((item) => {
      item.classList.remove('is_open');
    });
    document.querySelectorAll('.accordion__content').forEach((item) => {
      item.style.display = 'none';
    });
    faq.classList.add('is_open');
    if (content) {
      content.style.display = 'block';
    }
  }
});

// $(document).on('click', 'a[data-pagination-btn-blog]', function(event) {  
//   pagination_items_get_fun(this);
// });


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
        function image_hide(imag){
             let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
              images_val.forEach(b => {
              if(b.alt == imag){
                b.classList.remove("hidden");
              }else{
                b.classList.add("hidden");
              }
                });
          }
      let images = document.querySelector(".header__inline-menu").querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);

$(".header__icon--search").click(function(){
  $('.header').addClass('mobile_search_active');
});
$(".search-modal__close-button,.header__search .search-modal__content .reset__button").click(function(){
  $('.header').removeClass('mobile_search_active');
});

// Mobile Menu Search Bar Out Side Click On Close Search Js
$(document).mouseup(function(e) {
  var container = $(".search-modal__content,.facets__heading");
  if (!container.is(e.target) && container.has(e.target).length === 0) 
  {
    $('.header').removeClass('mobile_search_active');
    $('.facets__heading').removeClass('filter_active');
    $('.facets__wrapper').removeClass('dd_cm_filter');
  }
});

//slideshow

const swiper = new Swiper(".main_hero", {
  direction: "horizontal",
  grabCursor: true,
  slidesPerView: 1,
  centeredSlides: false,
  loop: false,
  spaceBetween: 10,
  paginationClickable: true,
  mousewheel: {
    forceToAxis: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true, // Ensures pagination is clickable
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
  speed: 700,
  slideActiveClass: "is-active",
  slideDuplicateActiveClass: "is-active"
});

//endslideshow

// Testimonail Slider JS
var swipertestimonial = new Swiper(".testimonail_slider_main", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-testimonial-button-next",
      prevEl: ".swiper-testimonial-button-prev",
    },
});

$(document).ready(function() {
  // Desktop Megamenu On Hover BG Color
  $('.mega_menu_hover').hover(
       function(){ $('.header-wrapper--sticky').removeClass('is-light') },
       function(){ $('.header-wrapper--sticky').addClass('is-light') }
  );
  // $('.mega_menu_hover').hover(
  //      function(){ $('.header-wrapper').removeClass('header-wrapper--sticky') },
  //      function(){ $('.header-wrapper').addClass('header-wrapper--sticky') }
  // );
});
// Mobile Menu First Dropdown 
  $('.first_nav_link_dropdown').click(function(){
   $('.menu-drawer__menu').addClass('first_child_menu_active');
  });
// Collection Filter Toggleclass JS
if ($(window).width() > 750) {
$('.facets__heading').click(function(){
  $(this).toggleClass('filter_active');
   $('#FacetsWrapperDesktop').toggleClass('dd_cm_filter');
});
}

if ($(window).width() < 750) {
$('.facets__heading').click(function(){
  $('.mobile-facets__open-wrapper').click();
});
}

if (window.innerWidth < 990) {
  const swipertextwithicon = new Swiper(".mobi_text_with_icon_slider", {
    slidesPerView: 2,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
}

// $(document).ready(function(){
//   $('.loadmorebtn').on('click', function(){
//     $('.product-form__input .item.hidden').slice(0, 4).removeClass('hidden');
//     if ($('.product-form__input .item.hidden').length == 0) {
//       $('.loadmorebtn').hide();
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', () => {

  const submitBtn = document.querySelector('#ProductSubmitButton-template--16980547928213__main');
  const targetElement = document.querySelector('.product_btn_cls');

  if (!submitBtn || !targetElement) return;

  function toggleElement() {
    if (submitBtn.hasAttribute('disabled')) {
      targetElement.style.display = 'none';
    } else {
      targetElement.style.display = 'block';
    }
  }

  toggleElement();

  const observer = new MutationObserver(toggleElement);

  observer.observe(submitBtn, {
    attributes: true,
    attributeFilter: ['disabled']
  });

});
